export const en = {
  appTitle: 'SightPlay',
  subtitle: 'Listen. Detect. Improve.',
  score: 'Score',
  streak: 'Streak',
  speed: 'Speed',
  accuracy: 'Accuracy',
  bpm: 'BPM',
  midiReady: 'MIDI Ready',
  target: 'Target',
  noteNameLabel: 'Note',
  solfegeLabel: 'Solfege',
  jianpuLabel: 'Jianpu',
  played: 'You played',
  tooHigh: 'Too High',
  tooLow: 'Too Low',
  perfect: 'Perfect! 🎉',
  challenge: 'Challenge',
  aiCoach: 'AI Coach',
  step: 'Step',
  thinking: 'Thinking...',
  defaultAi: "Hi! I'm your music coach. Ask me about theory or say 'Generate a song for me!'",
  btnChallenge: 'New Challenge',
  btnHint: 'Get Hint',
  btnMicStart: 'Start Mic',
  btnMicStop: 'Stop Mic',
  btnTreble: 'Treble Clef',
  btnBass: 'Bass Clef',
  micOn: 'Mic On',
  micError: 'Could not access microphone.',
  apiKeyError: 'Please provide an API Key to use AI features.',
  challengeComplete: 'Challenge Complete! Great job.',
  fallbackTitle: 'Fallback Scale',
  fallbackDesc: 'A simple C Major scale ascent.',
  practiceTip: 'Practice makes perfect!',
  listening: 'Listening...',
  showPiano: 'Show Piano',
  hidePiano: 'Hide Piano',
  inputPlaceholder: 'Ask theory or request a song...',
  send: 'Send',
  practiceRangeLabel: 'Practice Range',
  practiceRangeCentral: 'Middle Octave',
  practiceRangeUpper: 'Upper Octave',
  practiceRangeCombined: 'Middle + Upper',
  rightHand: 'Right Hand',
  leftHand: 'Left Hand',
  bothHands: 'Both Hands',
  aiError: "Sorry, I'm having trouble connecting. Try again?",
  hintGreatStreak: 'Great streak! Keep it up! 🔥',
  hintTrySlower: 'Try playing a bit slower and focus on accuracy.',
  hintKeepGoing: "Don't give up! Focus on the note position on the staff.",
  hintAwesome: 'Awesome! You nailed that one! 🎯',
  hintPracticeRange: 'Try narrowing your practice range to build confidence.',
  openAiChat: 'AI Coach',
  closeChat: 'Close',
  songLibrary: 'Song Library',
  difficulty_beginner: 'Beginner',
  difficulty_intermediate: 'Intermediate',
  difficulty_advanced: 'Advanced',
  allDifficulties: 'All Levels',
  category_classical: 'Classical',
  category_folk: 'Folk',
  category_exercise: 'Exercise',
  clef: 'Clef',
  trebleClef: 'Treble',
  bassClef: 'Bass',
  notes: 'notes',
  noSongsFound: 'No songs found',
  progress: 'Progress',
  time: 'Time',
  exitSong: 'Exit',
  songNotFound: 'Song not found',
  backToLibrary: 'Back to Library',
  songCompleteTitle: 'Song Complete!',
  correctNotes: 'Correct Notes',
  retrySong: 'Try Again',
  randomPractice: 'Random Practice',
  recTryBassTitle: 'Ready for a challenge?',
  recTryBassDesc: "You're doing great with treble clef — try bass clef!",
  recExpandRangeTitle: 'Expand your range',
  recExpandRangeDesc: "You've mastered the middle octave. Try the combined range!",
  recTrySongTitle: 'Try a song!',
  recTrySongDesc: 'Your note reading is strong. Practice with a real piece!',
  recNarrowRangeTitle: 'Focus your practice',
  recNarrowRangeDesc: 'Try the middle octave to build confidence with fewer notes.',
  recSlowDownTitle: "Let's slow down",
  recSlowDownDesc: 'Take your time — focus on reading each note carefully.',
  recTryHarderSongTitle: 'Level up!',
  recTryHarderSongDesc_intermediate: 'Great job! Try an intermediate song next.',
  recTryHarderSongDesc_advanced: 'Impressive! Ready for an advanced piece?',
  recKeepPracticingTitle: 'Keep it up!',
  recKeepPracticingDesc: 'Practice more songs or try random note reading.',
  recApply: 'Try it',
  authLoading: 'Loading...',
  authLoginTitle: 'Welcome Back',
  authLoginSubtitle: 'Sign in with your passkey to continue',
  authLoginButton: 'Sign In',
  authLoginLoading: 'Authenticating...',
  authNoAccountRegisterLink: "Don't have an account? Register with invite code",
  authRegisterTitle: 'Welcome to SightPlay',
  authRegisterSubtitle: 'Enter your invite code to set up your passkey',
  authInviteCodeLabel: 'Invite Code',
  authInviteCodePlaceholder: 'ABCD-EFGH',
  authPasskeyTitle: "What's a passkey?",
  authPasskeyDesc:
    "Passkeys use your device's biometric authentication (Face ID, Touch ID, or Windows Hello) to securely sign you in.",
  authRegisterLoading: 'Setting up...',
  authRegisterButton: 'Set up Passkey',
  inviteCodeLabel: 'Invite Code',
  inviteCodeValidFor: 'Valid for 7 days • One-time use',
  inviteCodeCopied: 'Copied!',
  inviteCodeCopy: 'Copy Code',
  inviteCodeGenerate: 'Generate Invite Code',
  inviteCodeGenerating: 'Generating...',
  inviteCodeFailed: 'Failed to generate invite code',
  passkeyManageTitle: 'Manage Passkeys',
  passkeyClose: 'Close',
  passkeyLoading: 'Loading...',
  passkeyEmpty: 'No passkeys found',
  passkeyAdded: 'Added',
  passkeyCannotRemoveLast: 'Cannot remove the last passkey',
  passkeyRemove: 'Remove',
  passkeyRemoveConfirm: 'Are you sure you want to remove this passkey?',
  passkeyRemoveFailed: 'Failed to remove passkey',
  authLogoutButton: 'Logout',
  authErrorCanceled: 'Authentication was canceled. Please try again.',
  authErrorNotSupportedDevice:
    'Your device does not support passkeys. Please use a device with biometric authentication.',
  authErrorConnectionTimeout: 'Connection timeout. Please check your network and try again.',
  authErrorUnknown: 'An unknown error occurred',
  authErrorPasskeysNotSupportedBrowser:
    'Passkeys are not supported on this browser. Please use a modern browser with biometric authentication support.',
  authErrorRegisterOptionsFailed: 'Failed to get registration options',
  authErrorRegisterVerificationFailed: 'Registration verification failed',
  authErrorLoginOptionsFailed: 'Failed to get authentication options',
  authErrorLoginVerificationFailed: 'Authentication verification failed',
  challengeStatusComplete: 'Complete!',
  midiActive: 'MIDI ACTIVE',
  challengeStatusActive: 'Active',
  aiQuickChallengePrompt: 'Generate a simple sight-reading challenge for {{clef}} clef.',
  aiQuickHintPromptWithNote: 'How do I play {{note}}?',
  aiQuickHintPromptFallback: 'Give me a tip.',
  aiChallengeLoaded: '{{challenge}}: {{title}} ({{count}} {{notes}}) loaded!',
  aiChallengeCompletedUserMessage: 'I finished the challenge! How did I do?',
  passkeyButtonTitle: 'Manage Passkeys',
  aiConnectionErrorMessage: 'Error connecting to AI.',
  errorBoundaryTitle: 'Something went wrong',
  errorBoundaryDescription: 'An unexpected error occurred. Please try again.',
  errorBoundaryRetry: 'Retry',
};
